import React from "react";
import TabBar from 'storybookComponents/TabBar'
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core';
import { styles } from "./style";
import Overview from "./TabViews/overview";
import UserContext from 'context/UserContext';
import { getAppPath } from "constants/path"
import DateRangePicker from "components/DateRangePicker"
import moment from "moment"
import "moment-timezone"
import ReportsTable from "./TabViews/ReportsTable"
import { tabValues } from "./TabViews/utils";
const path = {
  0: "/reports-overview",
  1: "/reports-properties",
  2: "/reports-events",
  3: "/reports-invitees"
}

const Reports = ({ classes, setTitle, showNotification, activeTab, setOriginNavItems, orgLevel, setOrgLevel, isNotificationsBarVisible, ...props }) => {

  const { subOrgDetails } = React.useContext(UserContext);
  const [tabIndex, setTabIndex] = React.useState(activeTab);
  const [monthRange, setMonthRange] = React.useState({ startAt: moment().tz(subOrgDetails.timezoneString).startOf("month"), endAt: moment().tz(subOrgDetails.timezoneString).endOf("month"), label: "This Month" });


  React.useEffect(() => {
    setTitle([
      {
        label: "Events",
        to: getAppPath()
      },
      {
        label: "Reports",
        to: "/"
      }
    ])
    setTabIndex(activeTab);
    if (!orgLevel) {
      if (props.history.location.pathname.includes("/reports-properties")) {
        handleTabChange(0);
      }
    }
    setOriginNavItems(orgLevel);
  }, [activeTab, orgLevel])

  const handleTabChange = (index) => {
    let idx = index;
    setTabIndex(idx);
    if (!orgLevel && idx > 0) {
      idx++;
    }
    props.history.push(getAppPath() + path[idx]);
  }


  const handleChangeRange = (v) => {
    setMonthRange(v);
  }

  const renderContent = () => {
    switch (tabIndex) {
      case 0:
        return <Overview monthRange={monthRange} subOrgDetails={subOrgDetails} />
      case 1:
        return <ReportsTable tabIndex={tabIndex} monthRange={monthRange} setMonthRange={setMonthRange} subOrgDetails={subOrgDetails} orgLevel={orgLevel} />
      case 2:
        return <ReportsTable tabIndex={tabIndex} monthRange={monthRange} setMonthRange={setMonthRange} subOrgDetails={subOrgDetails} orgLevel={orgLevel} />
      case 3:
        return <ReportsTable tabIndex={tabIndex} monthRange={monthRange} setMonthRange={setMonthRange} subOrgDetails={subOrgDetails} orgLevel={orgLevel} />
      default:
        break
    }
  }
  return (
    <Box className={`${classes.superContainer} ${isNotificationsBarVisible && classes.customRoot}`}>
      <Box className={classes.headerBar}>
        <TabBar
          tabs={orgLevel ? tabValues : [tabValues[0], ...tabValues.slice(2)]}
          onChange={handleTabChange}
          index={tabIndex}
        />
        {
          tabIndex === 0 && <DateRangePicker timezoneString={subOrgDetails.timezoneString} value={monthRange} position="right" handleApply={handleChangeRange} />
        }

      </Box>
      {renderContent()}
    </Box>
  )
}

export default withStyles(styles)(Reports)
